import React from 'react';
import styles from './Map.module.scss';

function Main() {
    return (
        <div className={styles.imgbox}>
            <img className={styles.centerFit} style={{ maxHeight: '70vh' }} src="/Map_2025.svg" alt="Map 2025" />
        </div>
    );
}

export default Main;
